<script>
import {defineComponent} from 'vue'
import MobileTopBar from "@js/components/TopBar/MobileTopBar.vue";
import MapComponent from "@js/components/Sections/Contacts/MapComponent.vue";
import IconMapPoint from "@js/components/Icons/IconMapPoint.vue";
import IconEnvelope from "@js/components/Icons/IconEnvelope.vue";
import IconClock from "@js/components/Icons/IconClock.vue";
import IconPhone from "@js/components/Icons/IconPhone.vue";
import SalesDepartmentPhone from "@js/components/Sections/Links/SalesDepartmentPhone.vue";
import Breadcrumbs from "@js/components/Breadcrumbs/Breadcrumbs.vue";
import IconWhatsApp from "@js/components/Icons/IconWhatsApp.vue";
import IconTelegram from "@js/components/Icons/IconTelegram.vue";
import IconChatFilled from "@js/components/Icons/IconChatFilled.vue";
import {useJivoStore} from "@js/store/JivoStore.js";
import RequisiteTable from "@js/components/Sections/Contacts/RequisiteTable.vue";
import {contacts} from "@js/company_details.ts";
import CommerceDepartmentPhone from "@js/components/Sections/Links/CommerceDepartmentPhone.vue";
import LogisticDepartmentPhone from "@js/components/Sections/Links/LogisticDepartmentPhone.vue";
import IconMax from "@js/components/Icons/IconMax.vue";

export default defineComponent({
    name: "ContactsPage",
    components: {
        IconMax,
        LogisticDepartmentPhone,
        CommerceDepartmentPhone,
        RequisiteTable,
        IconChatFilled,
        IconTelegram,
        IconWhatsApp,
        Breadcrumbs,
        SalesDepartmentPhone,
        IconPhone,
        IconClock,
        IconEnvelope,
        IconMapPoint,
        MapComponent,
        MobileTopBar,
    },
    setup() {
        const jivoStore = useJivoStore()

        return {jivoStore, contacts}
    }
})
</script>

<template>
    <MobileTopBar/>
    <div class="container">
        <Breadcrumbs/>
        <h1 class="text-2xl md:text-3xl font-bold">
            Контакты и обратная связь
        </h1>
        <div class="relative grid grid-cols-12 gap-5 mb-5 mt-5">
            <div class="col-span-12 lg:col-span-7">
                <div
                    class="border rounded-3xl border-[#FFFFFF80] bg-grayBg p-5 md:p-8 flex flex-col gap-5 mb-5">
                    <div class="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-10">
                        <div>
                            <p class="flex items-center gap-1 font-medium">
                                <IconMapPoint class="w-6 h-6 mb-1"/>
                                Адрес
                            </p>
                            <a :href="contacts.yandex_map_link" target="_blank"
                               class="hover:text-navHoverColor text-sm transition">
                                {{ contacts.address }}
                            </a>
                        </div>
                        <div>
                            <p class="flex items-center gap-1 font-medium">
                                <IconEnvelope class="w-6 h-6 mb-1"/>
                                Почта
                            </p>
                            <a :href="'mailto:' + contacts.info_mail" target="_blank"
                               class="hover:text-navHoverColor text-sm transition">
                                {{ contacts.info_mail }}
                            </a>
                        </div>
                        <div class="font-medium">
                            <p class="flex items-center gap-1 font-medium">
                                <IconClock class="w-6 h-6 mb-1"/>
                                Режим работы
                            </p>
                            <p class="text-sm">
                                Пн-Вс: 08:00 - 20:00
                            </p>
                        </div>
                    </div>
                </div>
                <div
                    class="border rounded-3xl border-[#FFFFFF80] bg-grayBg p-5 md:p-8 flex flex-col gap-5 mb-5">
                    <div class="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-10">
                        <div>
                            <p class="flex gap-1 font-medium">
                                <IconPhone class="w-6 h-6 mb-1"/>
                                Отдел продаж
                            </p>
                            <div class="flex items-center gap-5 ms-7">
                                <SalesDepartmentPhone
                                    class="text-sm md:text-base md:hover:text-navHoverColor transition"/>
                            </div>
                        </div>
                        <div>
                            <p class="flex gap-1 font-medium">
                                <IconPhone class="w-6 h-6 mb-1"/>
                                Отдел Коммерции
                            </p>
                            <div class="flex items-center gap-5 ms-7">
                                <CommerceDepartmentPhone
                                    class="text-sm md:text-base md:hover:text-navHoverColor transition"/>
                            </div>
                        </div>
                        <div>
                            <p class="flex gap-1 font-medium">
                                <IconPhone class="w-6 h-6 mb-1"/>
                                Отдел Логистики
                            </p>
                            <div class="flex items-center gap-5 ms-7">
                                <LogisticDepartmentPhone
                                    class="text-sm md:text-base md:hover:text-navHoverColor transition"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="bg-grayBg px-2 md:px-5 py-5 border border-[#FFFFFF80] rounded-3xl w-full flex flex-col items-center justify-center">
                    <p class="font-bold text-lg md:text-xl">
                        Не хотите звонить? Пишите!
                    </p>
                    <p class="text-sm md:text-md">
                        Все способы связаться с нами онлайн
                    </p>
                    <div class="grid grid-cols-5 mt-5 gap-1 md:gap-5">
                        <!--Почта-->
                        <div @click.prevent="jivoStore.openJivoChat"
                             class="flex flex-col items-center min-w-[75px] cursor-pointer">
                            <div class="w-10 h-10 rounded-full bg-baseColor flex items-center justify-center">
                                <IconChatFilled class="w-5 h-5 "/>
                            </div>
                            <div class="font-medium text-xs md:text-sm mt-2">
                                Онлайн чат
                            </div>
                        </div>
                        <!--Почта-->
                        <!--WhatsApp-->
                        <a v-if="contacts.whatsapp" :href="contacts.whatsapp"
                           target="_blank" class="flex flex-col items-center min-w-[75px]">
                            <div class="w-10 h-10 rounded-full bg-whatsapp flex items-center justify-center">
                                <IconWhatsApp class="w-5 h-5 text-white"/>
                            </div>
                            <div
                                class="font-medium text-xs md:text-sm mt-2">
                                WhatsApp
                            </div>
                        </a>
                        <!--WhatsApp-->
                        <!--Telegram-->
                        <a v-if="contacts.telegram" :href="contacts.telegram" target="_blank"
                           class="flex flex-col items-center min-w-[75px]">
                            <div class="w-10 h-10 rounded-full bg-telegram flex items-center justify-center">
                                <IconTelegram class="w-5 h-5 text-white -ms-0.5"/>
                            </div>
                            <div class="font-medium text-xs md:text-sm mt-2">
                                Telegram
                            </div>
                        </a>
                        <!--Telegram-->
                        <!--Max-->
                        <a v-if="contacts.max" :href="contacts.max" target="_blank"
                           class="flex flex-col items-center min-w-[75px]">
                            <div class="w-10 h-10 rounded-full flex items-center max-gradient justify-center">
                                <IconMax class="w-5 h-5 text-white"/>
                            </div>
                            <div class="font-medium text-xs md:text-sm mt-2">
                                Max
                            </div>
                        </a>
                        <!--Max-->
                        <!--Почта-->
                        <a v-if="contacts.info_mail" :href="'mailto:' + contacts.info_mail" class="flex flex-col items-center min-w-[75px]">
                            <div class="w-10 h-10 rounded-full bg-baseColor flex items-center justify-center">
                                <IconEnvelope class="w-5 h-5 "/>
                            </div>
                            <div class="font-medium text-xs md:text-sm mt-2">
                                Почта
                            </div>
                        </a>
                        <!--Почта-->
                    </div>
                </div>
            </div>
            <div
                class="col-span-12 lg:col-span-5 sticky top-24 self-start border-2 border-baseColor rounded-3xl overflow-hidden w-full h-[450px]">
                <MapComponent/>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
